import * as Yup from 'yup';

export const schema = Yup.object().shape({
  GameName: Yup.string().required('وارد کردن عنوان بازی الزامی است'),
  GameURL: Yup.string().required('وارد کردن لینک بازی الزامی است'),
  GameLogo: Yup.string().required('وارد کردن لوگوی بازی الزامی است'),
  GameTitleButton: Yup.string().required('وارد کردن عنوان دکمه بازی الزامی است'),
  // GameSize: Yup.number()
  //   .typeError('لطفا حجم بازی را بصورت عدد وارد کنید')
  //   .min(0, 'مقدار باید 0 یا بیشتر باشد')
  //   .required('وارد کردن حجم بازی الزامی است'),
  // GameVersion: Yup.string().required('وارد کردن ورژن بازی الزامی است'),
  // GameAvrageRate: Yup.number()
  //   .typeError('لطفا میانگین امتیاز بازی را بصورت عدد وارد کنید')
  //   .min(0, 'مقدار باید 0 یا بیشتر باشد')
  //   .required('وارد کردن حجم بازی الزامی است'),
});
